export const CLEAR = "CLEAR";

export const FETCH = "FETCH";
export const FETCH_FAILURE = "FETCH_FAILURE";
export const FETCH_SUCCESS = "FETCH_SUCCESS";

export const WITHDRAW = "WITHDRAW";
export const WITHDRAW_FAILURE = "WITHDRAW_FAILURE";
export const WITHDRAW_SUCCESS = "WITHDRAW_SUCCESS";



// WEBPACK FOOTER //
// ./src/components/withdrawal/withdrawalActionTypes.js